import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material';
import Badge from '@mui/material/Badge';

import { useSession, useToastError } from '@hooks';
import { useListNotificationsQuery } from '@graphql';

interface NotificationButtonProps {
  handleOpenDrawer: (event: React.MouseEvent<HTMLElement>) => void;
}

export function NotificationButton(props: Readonly<NotificationButtonProps>) {
  const { handleOpenDrawer } = props;
  const { account } = useSession();
  const theme = useTheme();
  const toastError = useToastError();

  const { data } = useListNotificationsQuery({
    skip: !account,
    onError: toastError,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
  });

  const unreadNotifiations = React.useMemo(() => {
    const count = data?.notifications.filter((n) => Boolean(n.count)).length ?? 0;
    return count;
  }, [data?.notifications]);

  if (!account) {
    return null;
  }

  return (
    <Tooltip title="Notifications">
      <IconButton data-id="notification" onClick={handleOpenDrawer}>
        <Badge color="error" badgeContent={unreadNotifiations}>
          <theme.icons.notification
            sx={{
              color: theme.palette.text.secondary,
              '&:hover': { color: theme.palette.text.primary },
            }}
          />
        </Badge>
      </IconButton>
    </Tooltip>
  );
}
